/**
 * @author PengWen
 * @description zoneCode管理
 * @Date 2022/10/21
 */
 import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateConfig } from "./config";

import { component_tool, framework_tool } from '../../../tool';
let { WizContainer, WizReduxTemplate, modelUtils } = framework_tool;
let { WizBrowserExport } = component_tool;


class RequirementPositionOrderManager extends WizContainer {
  componentName = 'RequirementPositionOrderManager';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleCMD(nextProps, nextState, key){
    let o = nextProps[key];
    if (o['success']) {
      wizNotice.success(o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
     
      {
        headerName: '品牌',
        field: 'orgName',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '站点类型',
        field: 'dealerTypeCh',
        width: 80,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
    
      {
        headerName: '状态',
        field: 'state',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      }
    ]
    
    if (o['success']) {
      let data = o['data']
      data && data.forEach(e => {
        e['state'] == 0 ? e['state'] = "无效" : e['state'] = "有效"
      })
      WizBrowserExport({
        title: '岗位排序',
        sheetName: '岗位排序',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '岗位排序.xlsx',
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig,
      apiDataFormat: {
        delete: this._handleCMD,
        update: this._handleCMD,
        enable: this._handleCMD,
        export: this._handleFile,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateConfig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
};

export default connect(mapStateToProps)(RequirementPositionOrderManager);